import React from 'react';
import * as App from 'modules/app/App'

class UserTitle extends React.Component {

    constructor(props) {
        super(props);

        this.state = { open: false }
    }

    render() {
        const context = App.context();

        if (!context.impersonating)
            return (
                <React.Fragment>
                    <span>{context.userName}</span>
                </React.Fragment>);
        else 
            return (
                <React.Fragment>
                    <span>{context.auditUserName} (as {context.userName})</span>
                </React.Fragment>);        
    }
}

export default UserTitle;


// WEBPACK FOOTER //
// ./src/layouts/main/userCard/UserTitle.js